import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

//components
import FloatNumberFormatText from '../../../components/float_number_text_formatter';
import NeuriteGrid from '../../../components/neurite_grid';

//material:
import { withStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    bigTable: {
        margin: 0,
        padding: 0,
        height: 185,
        width: 810,
        overflow: 'hidden'
    },
    containerRightTable: {
        marginTop: 8,
        display: 'flex',
        fontSize: 10,
        border: `1px solid #dddddd`,
    },
    columnLeft: {
        width: 95,
    },
    columnRight: {
        width: 85,
    },
    gridCells: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: 35,
        width: 'inherit',
        padding: '0 8px',
        '&:nth-child(odd)': {
            backgroundColor: '#e8f1d7',
        },
        borderLeft: `1px solid #dddddd`,
        borderBottom: `1px solid #dddddd`,
    },
    gridCellsNumbers: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontWeight: 800,
        textAlign: 'right',
        height: 35,
        width: 'inherit',
        padding: '0 12px',
        '&:nth-child(odd)': {
            backgroundColor: '#e8f1d7',
        },
        borderLeft: `1px solid #dddddd`,
        borderBottom: `1px solid #dddddd`,
        borderRight: `1px solid #dddddd`,
    },
    gridCellsNumbersGreen: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontWeight: 800,
        textAlign: 'right',
        height: 35,
        width: 'inherit',
        padding: '0 12px',
        backgroundColor: 'green',
        color: 'white',
        borderLeft: `1px solid #dddddd`,
        borderBottom: `1px solid #dddddd`,
        borderRight: `1px solid #dddddd`,
    },
    gridCellsNumbersRed: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontWeight: 800,
        textAlign: 'right',
        height: 35,
        width: 'inherit',
        padding: '0 12px',
        backgroundColor: 'red',
        color: 'white',
        borderLeft: `1px solid #dddddd`,
        borderBottom: `1px solid #dddddd`,
        borderRight: `1px solid #dddddd`,
    },
    headerCell: {
        background: '#f9f9f9',
        fontSize: 10,
        fontWeight: 800,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: 35,
        width: 'inherit',
        padding: '0 8px',
        borderBottom: `1px solid #dddddd`,
        borderLeft: `1px solid #dddddd`,
    },
});


class TopSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            repCierraDia: !this.props.otrosDatosCierreSemanal.repCierraDia ? [] : this.props.otrosDatosCierreSemanal.repCierraDia,
            cambioCompl: !this.props.datosCierreSemanal ? 0.0 : this.props.datosCierreSemanal.totalEurosMaq - this.props.datosCierreSemanal.totalBillares - this.props.datosCierreSemanal.totalCambio
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreSemanal !== this.props.otrosDatosCierreSemanal) {

            this.setState({
                repCierraDia: !this.props.otrosDatosCierreSemanal.repCierraDia ? [] : this.props.otrosDatosCierreSemanal.repCierraDia,
                cambioCompl: !this.props.datosCierreSemanal ? 0.0 : this.props.datosCierreSemanal.totalEurosMaq - this.props.datosCierreSemanal.totalBillares - this.props.datosCierreSemanal.totalCambio
            });
        };
    };

    render() {

        const { classes } = this.props;

        /* const rows = this.props.otrosDatosCierreSemanal.repCierraDia.map((r, i) => {
            if (i == 0) return { ...r, arcade: r.arcade + this.state.cambioCompl };
            else return r;
        }); */

         return (
            <div className={classes.container}>
                <div className={classes.bigTable}>
                    {this.props.otrosDatosCierreSemanal.repCierraDia ?
                        <NeuriteGrid
                        id="t_s"
                            columns={[
                                { key: 'diario', name: 'Semanal', editable: false, dragable: false, width: 80 },
                                { key: 'bolera', name: 'Bolera', editable: false, dragable: false, width: 65, type: 'float' },
                                { key: 'bar', name: 'Bar', editable: false, dragable: false, width: 65, type: 'float' },
                                { key: 'porcentaje', name: '%', editable: false, dragable: false, width: 40, type: 'float' },
                                { key: 'arcade', name: 'Arcade', editable: false, dragable: false, width: 65, type: 'float' },
                                { key: 'otrosJuegos', name: 'Billares O/J', editable: false, dragable: false, width: 65, type: 'float' },
                                { key: 'parqueInf', name: 'Parque Inf', editable: false, dragable: false, width: 65, type: 'float' },
                                { key: 'cumpleaños', name: 'Fiestas', editable: false, dragable: false, width: 65, type: 'float' },
                                { key: 'totales', name: 'Totales', editable: false, dragable: false, width: 65, type: 'float' },
                                { key: 'niños', name: 'Niños', editable: false, dragable: false, width: 40, type: 'int' },
                                { key: 'partidas', name: 'Partidas', editable: false, dragable: false, width: 55, type: 'int' },
                                { key: 'promedio', name: 'Pre. Med.', editable: false, dragable: false, width: 55, type: 'float' },
                                { key: 'entrKids', name: 'Ent. Kids', editable: false, dragable: false, width: 55, type: 'int' },
                            ]}
                            rows={this.props.otrosDatosCierreSemanal.repCierraDia}
                            //rows = {rows}
                            headerRenderer={{ color: 'black', bg: grey[300], border: 'none', align: 'left' }}
                            height={220}
                            width={820}
                            fontSize={10}
                            buttonEdit={false}
                            buttonDelete={false}
                            buttonNew={false}
                            alternateRows={true}
                        />
                        : ''}
                </div>

                {this.props.otrosDatosCierreSemanal.repCierraDia ?
                    <div className={classes.containerRightTable}>
                        <div className={classes.columnLeft}>
                            {/* first column */}
                            <div className={classes.headerCell}>Diferencias</div>
                            {this.props.otrosDatosCierreSemanal.repCierraDia.map((row, i) => (<div key={i} className={classes.gridCells}>{row.diario}</div>))}
                        </div>

                        <div className={classes.columnRight}>
                            {/* second column */}
                            <div className={classes.headerCell}>Diferencia</div>
                            <div className={classes.gridCellsNumbers}> </div>

                            <div className={this.props.otrosDatosCierreSemanal.repCierraDia[1].diferencia > 0 ?
                                classes.gridCellsNumbersGreen : classes.gridCellsNumbersRed}>
                                <FloatNumberFormatText
                                    value={this.props.otrosDatosCierreSemanal.repCierraDia[1].diferencia}
                                />
                            </div>
                            <div className={this.props.otrosDatosCierreSemanal.repCierraDia[2].diferencia > 0 ?
                                classes.gridCellsNumbersGreen : classes.gridCellsNumbersRed}>
                                <FloatNumberFormatText
                                    value={this.props.otrosDatosCierreSemanal.repCierraDia[2].diferencia}
                                />
                            </div>
                            {this.props.otrosDatosCierreSemanal.repCierraDia[3] ?
                                <div className={this.props.otrosDatosCierreSemanal.repCierraDia[3].diferencia > 0 ?
                                    classes.gridCellsNumbersGreen : classes.gridCellsNumbersRed}>
                                    <FloatNumberFormatText
                                        value={this.props.otrosDatosCierreSemanal.repCierraDia[3].diferencia}
                                    />
                                </div>
                                :
                                <div></div>
                            }
                        </div>
                    </div>
                    : ''
                }
            </div>

        );
    };
};


TopSection.propTypes = {
    otrosDatosCierreSemanal: PropTypes.object.isRequired,
    datosCierreSemanal: PropTypes.object.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreSemanal: state.otrosDatosCierreSemanal.otrosdatos,
        datosCierreSemanal: state.datosCierreSemanal.datos,
    };
};

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TopSection));
